import { jsx } from "react/jsx-runtime";
import { createContext, useState, useReducer, useCallback, useMemo } from "react";
const ToasterContext = createContext(void 0);
const toasterReducer = (toasts, action) => {
  switch (action.type) {
    case "dismissToast":
      return toasts.filter((it) => it.id !== action.toastId);
    case "showToast":
      return [...toasts, action.toast];
  }
};
const ToasterProvider = (props) => {
  const [counter, setCounter] = useState(1);
  const [toasts, dispatch] = useReducer(toasterReducer, []);
  const dismissToast = useCallback((toastId) => {
    dispatch({ type: "dismissToast", toastId });
  }, []);
  const showToast = useCallback((toast) => {
    const id = String(counter);
    dispatch({ type: "showToast", toast: { ...toast, id } });
    setCounter((it) => it + 1);
    return id;
  }, [counter]);
  const toasterContextValue = useMemo(() => ({
    toasts,
    dismissToast,
    showToast
  }), [dismissToast, showToast, toasts]);
  return /* @__PURE__ */ jsx(ToasterContext.Provider, { value: toasterContextValue, children: props.children });
};
export {
  ToasterContext,
  ToasterProvider
};
//# sourceMappingURL=ToasterContext.js.map
